import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpService } from '../../service/http.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-view-horoscope-report',
  standalone: true,
  imports: [CommonModule,FormsModule],
  templateUrl: './view-horoscope-report.component.html',
  styleUrl: './view-horoscope-report.component.scss'
})
export class ViewHoroscopeReportComponent {
  @Output()
  close = new EventEmitter<boolean>();

  @Input()
  orderId:any;

  reportId:any
  reportOrderData:any

  constructor(private _route:ActivatedRoute,private _homeService:HttpService,private toastr: ToastrService) { }

  ngOnInit(): void {

    this.reportId=this.orderId;
    console.log(this.reportId);
    this.getHoroscopeReport();
    
  }

  getHoroscopeReport(){
    this._homeService.getReportOrderData(this.reportId).subscribe((data)=>{
      let value: any = data;
      this.reportOrderData = value?.data;
      console.log(this.reportOrderData.data); 
      
    },(error)=>{
      console.log("error");
      
    })

  }


  handleOffcanvasClose() {
    console.log('Offcanvas closed!');
    this.close.emit(true);
    // Add your logic here when the offcanvas is closed
  }
}
